import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'black-teach-faq-section',
  templateUrl: './teach-faq-section.component.html',
  styleUrls: ['./teach-faq-section.component.css'],
  standalone: true,
  imports: [CommonModule],
})
export class TeachFaqSectionComponent {
  openFaqIndex: number | null = 0;

  toggleFaq(index: number): void {
    this.openFaqIndex = this.openFaqIndex === index ? null : index;
  }
}
